let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dK2nG")).then(() => parcelRequire('6LiLg'));